import { render, staticRenderFns } from "./add-document-modal.vue?vue&type=template&id=34931c2f"
import script from "./add-document-modal.vue?vue&type=script&lang=js"
export * from "./add-document-modal.vue?vue&type=script&lang=js"
import style0 from "./add-document-modal.vue?vue&type=style&index=0&id=34931c2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports